import { Badge } from "@thilke/ui/components/badge";
import { cn } from "@thilke/ui/lib/utils";
import { Star } from "lucide-react";
import type * as React from "react";

function RepoCardBlock({
  className,
  ...props
}: React.ComponentProps<"article">) {
  return (
    <article
      data-slot="repo-card-block"
      className={cn(
        "grid gap-3 rounded-lg border bg-card p-4 text-card-foreground",
        className,
      )}
      {...props}
    >
      <div className="flex items-start justify-between gap-3">
        <div>
          <h3 className="font-semibold">thilke/ui</h3>
          <p className="text-sm text-muted-foreground">
            Repository package summary.
          </p>
        </div>
        <Badge variant="secondary">TypeScript</Badge>
      </div>
      <p className="text-sm">
        Shared shadcn-compatible primitives, blocks, and VTT surfaces.
      </p>
      <div className="flex flex-wrap items-center gap-2 text-xs text-muted-foreground">
        <span className="inline-flex items-center gap-1">
          <Star className="size-3.5" /> 113
        </span>
        <span>MIT</span>
        <span>ui registry</span>
      </div>
    </article>
  );
}

export { RepoCardBlock };
